// Manifesting Console deep-link constants (used by the Manifest Visibility popup).

// Manifesting Console Harmony host per EagleEye stage — stage-matched so a user
// stays within their stage's data (EagleEye integ/local maps to beta).
export const MANIFESTING_CONSOLE_BASE_URL: Record<"prod" | "gamma" | "beta", string> = {
    prod: "https://manifesting-console.harmony.a2z.com",
    gamma: "https://manifesting-console.gamma.harmony.a2z.com",
    beta: "https://manifesting-console.beta.harmony.a2z.com",
};

/** EagleEye realm -> Manifesting Console region path value. */
export const MANIFESTING_CONSOLE_REGION: Record<string, string> = { na: "NA", eu: "EU", fe: "FE" };

/** Length of the pre-filled lookup window, in days, from the TCDA creation date. */
export const CONSOLE_WINDOW_DAYS = 3;
